// components/CommunityGroupCard/CommunityGroupCard.tsx
type Props = {
  title: string;
  description: string;
  link: string;
  languages: string[];
};

export default function GroupCard({
  title,
  description,
  link,
  languages,
}: Props) {
  return (
    <div className="relative bg-white border border-[#D3DC7C] rounded-lg shadow-md p-4 text-[#1B475D]">
      {/* Language badge */}
      <div className="absolute bottom-3 right-3 flex gap-1 flex-wrap justify-end">
        {languages.map((lang) => (
          <span
            key={lang}
            className="bg-[#8EBD9D] text-[#1B475D] text-xs font-semibold px-2 py-0.5 rounded-full"
          >
            {lang}
          </span>
        ))}
      </div>

      <h3 className="text-lg font-bold mb-2">{title}</h3>
      <p className="text-sm mb-3 text-[#1B475D]/80">{description}</p>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="inline-block text-md font-medium text-[#1B475D] underline hover:text-[#15374B]"
      >
        Join Group →
      </a>
    </div>
  );
}
